import { render } from "./HomeFooter.vue?vue&type=template&id=2120f4ed&scoped=true"
import script from "./HomeFooter.vue?vue&type=script&lang=js"
export * from "./HomeFooter.vue?vue&type=script&lang=js"

import "./home-footer-responsive.css?vue&type=style&index=0&lang=css&external"
import "./HomeFooter.vue?vue&type=style&index=1&id=2120f4ed&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2120f4ed"]])

export default __exports__